import { Injectable } from '@angular/core';
import {ContextMenu} from "./context-menu";
import {ContextMenuItem} from "./context-menu-item";
import {ContextMenuSeparator} from "./context-menu-separator";
import {ContextMenuActionCallback} from "./context-menu-types";

@Injectable({
  providedIn: 'root'
})
export class ContextMenuService {

  constructor() { }

  createContextMenu(): ContextMenu {
    return new ContextMenu();
  }

  createContextMenuItem(label: string, actionCallback: ContextMenuActionCallback, labelSuffix: string, prefixIcon: string) {
    return new ContextMenuItem(label, actionCallback, labelSuffix, prefixIcon);
  };

  createContextMenuSeparator() {
    return new ContextMenuSeparator();
  }
}
